import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Grid,
  Divider,
} from "@material-ui/core";

import AiBriefingBoard from "./AiBriefingBoard";
import NonActivityBoard from "./NonActivityBoard";
import CautionBoard from "./CautionBoard";
import EmergencyBoard from "./EmergencyBoard";
import ActivityBoard from "./ActivityBoard";
import AbsenceBoard from "./AbsenceBoard";
import DeviceStatusBoard from "./DeviceStatusBoard";

import EmergencyTable from "./EmergencyTable";
import CautionTable from "./CautionTable";
import InquiryTable from "./InquiryTable";
import DeviceStatusTable  from "./DeviceStatusTable";
import RoomsCardView from "./RoomsCardView";

import { CONFIG_SETTINGS, SIREN_COLOR } from 'config.js';

import { ImageDialog } from "views/ImageDialog"


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    // height: "90vh",
  },
  policy: {
    // marginTop: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },

  tableSection: {
  },

  statCardsWrapper: {
    [theme.breakpoints.up('lg')]: {
      height: '100%',
    },
  },

  statCardsColumn: {
    [theme.breakpoints.up('lg')]: {
      height: '100%',
    },
  },

  sectionDivider: {
    margin: theme.spacing(1, 0),
    // backgroundColor: 'lightgray',
    backgroundColor: SIREN_COLOR.ABSENCE_BG_COLOR,
    height: 2,
  },
}));

const Dashboard = (props) => {
  const classes = useStyles();

  const [displayDeviceHealthCheck, setDisplayDeviceHealthCheck] = useState("on");

  const emergencyRowPerPage = localStorage.getItem(CONFIG_SETTINGS.EmergencyRowsPerPage);
  const CautionRowsPerPage = localStorage.getItem(CONFIG_SETTINGS.CautionRowsPerPage);
  const DeviceRowsPerPage = localStorage.getItem(CONFIG_SETTINGS.DeviceRowsPerPage);


  useEffect(() => {

    const display_device_health_check = localStorage.getItem(CONFIG_SETTINGS.DisplayDeviceHealthCheck);
    setDisplayDeviceHealthCheck(display_device_health_check);

  }, []);


  return (
    <div className={classes.root}>

      <ImageDialog  />


      <Grid
        container
        spacing={1}
        align="center"
        justifyContent="flex-start"
        direction="row"
      >

        <Grid container item spacing={1} alignItems="stretch">
          <Grid item lg={5} md={12} xs={12}>
            <AiBriefingBoard />
          </Grid>

          <Grid item lg={7} md={12} xs={12} className={classes.statCardsWrapper}>
            <Grid container direction="column" justifyContent="space-between" spacing={1} className={classes.statCardsColumn}>
              <Grid item>
                <Grid container spacing={1}>
                  <Grid item lg={4} md={4} xs={4}>
                    <EmergencyBoard />
                  </Grid>

                  <Grid item lg={4} md={4} xs={4}>
                    <CautionBoard />
                  </Grid>

                  <Grid item lg={4} md={4} xs={4}>
                    <ActivityBoard />
                  </Grid>

                  {/* <Grid item lg={2} md={4} >
                    <QuiverBoard />
                  </Grid> */}
                </Grid>
              </Grid>

              <Grid item>
                <Grid container spacing={1}>
                  <Grid item lg={4} md={4} xs={4}>
                    <NonActivityBoard />
                  </Grid>

                  <Grid item lg={4} md={4} xs={4}>
                    <AbsenceBoard />
                  </Grid>

                  <Grid item lg={4} md={4} xs={4}>
                    <DeviceStatusBoard />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>


        <Grid container>
          <Grid item xs={5}></Grid>
          <Grid item xs={2}>
            <Divider className={classes.sectionDivider} />
          </Grid>
          <Grid item xs={5}></Grid>
        </Grid>

        <Grid container item className={classes.tableSection} spacing={1}>

          {displayDeviceHealthCheck === "on" ?
            ( <>
              <Grid item xl={6} lg={6} md={12} xs={12}><EmergencyTable emergencyRowPerPage={emergencyRowPerPage == 10 ? 10 : 5} /></Grid>
              <Grid item xl={3} lg={3} md={6} xs={12}><CautionTable CautionRowsPerPage={CautionRowsPerPage == 10 ? 10 : 5} /></Grid>
              <Grid item xl={3} lg={3} md={6} xs={12}><DeviceStatusTable DeviceRowsPerPage={DeviceRowsPerPage == 10 ? 10 : 5}/></Grid>
              </>
            )
              :
            (<>
            <Grid item xl={8} lg={8} md={12} xs={12}><EmergencyTable emergencyRowPerPage={emergencyRowPerPage == 10 ? 10 : 5} /></Grid>
            <Grid item xl={4} lg={4} md={12} xs={12}><CautionTable CautionRowsPerPage={CautionRowsPerPage == 10 ? 10 : 5}/></Grid>
            </>
            )}

          {/* <Grid item xl={6} lg={6} md={12} xs={12}><EmergencyTable /></Grid>
          <Grid item xl={3} lg={3} md={6} xs={12}><CautionTable /></Grid>
          <Grid item xl={3} lg={3} md={6} xs={12}><DeviceStatusTable /></Grid> */}
          {/* <Grid item lg={5} xs={12} ><InquiryTable /></Grid> */}
        </Grid>


        <Grid container item spacing={0}>
          <RoomsCardView />
        </Grid>

      </Grid>
    </div>
  );
};

export default Dashboard;
